import { addDaysIso } from '@gozoki/tools'

export interface HistoryBounds {
  /** Premier jour sélectionnable (`YYYY-MM-DD`). */
  earliest: string
  /** Hier : aujourd'hui, c'est le direct. */
  latest: string
}

/** Jours passés rejouables, `today` étant le jour civil de Paris : d'hier à `daysBack` jours. */
export const pastDayBounds = (today: string, daysBack: number): HistoryBounds => ({
  earliest: addDaysIso(today, -daysBack),
  latest: addDaysIso(today, -1),
})

/**
 * Profondeur de l'historique des projections de réappro (vues Production et Logistique), en jours.
 * La purge (`forecastRetention.service` du backend) garde tous les calculs
 * `FORECAST_FULL_ANCHOR_WEEKS` (2 semaines), puis seulement celui du lundi.
 */
export const REAPPRO_PROJECTION_HISTORY_DAYS = 13
